export default class CalendarDescriptionCreator {

    extractTable(text) {
        if (text == null) {
            return ""
        }

        const regex = /(<table>[\s\S]*?<\/table>)/
        const match = text.match(regex)
        return match ? match[1].trim() : null
    }

    createTableViewDescription(tableHTML) {
        const tempDiv = document.createElement("div")
        tempDiv.innerHTML = tableHTML
        if (tempDiv.children.length == 0 || tempDiv.children.item(0).tagName != 'TABLE') {
            return ""
        }

        let table = document.createElement("table")
        table.style.textAlign = 'left'
        table.style.width = '100%'
        table.style.minWidth = '600px'
        table.style.borderCollapse = 'collapse'
        table.style.border = '1px solid black'
        //table.style.maxWidth = '900px'
        for (var i = 0, row; row = tempDiv.children[0].rows[i]; i++) {
            let tr = document.createElement("tr")
            tr.style.border = '1px solid black'
            for (var j = 0, col; col = row.cells[j]; j++) {
                let td = document.createElement("td")
                td.innerText = col.innerText
                td.style.textAlign = 'center'
                td.style.padding = '5px'
                td.style.maxWidth = '150px'
                td.style.minWidth = '100px'
                td.style.border = '1px solid black'
                tr.appendChild(td)
            }
            table.appendChild(tr)
        }

        return table

    }

    getViewsDescriptionToInject(splittedDescription, tables) {
        let views = []
        let tableIndex = 0

        splittedDescription.forEach((part) => {
            if (part === "{table}" && tables[tableIndex]) {
                views.push(tables[tableIndex])
                tableIndex++
            } else {
                const paragraph = document.createElement("p")
                paragraph.textContent = part
                views.push(paragraph)
            }
        })
        return views
    }

    parseDescription(desc) {
        let table
        let tables = []
        while ((table = this.extractTable(desc)) !== null) {
            desc = desc.replace(table, "@@SEP@@{table}@@SEP@@")
            tables.push(this.createTableViewDescription(table))
        }

        const splittedDescription = desc.split("@@SEP@@")
        return this.getViewsDescriptionToInject(splittedDescription, tables)
    }

    create(desc) {
        let parsedContent = this.parseDescription(desc)
        let container = document.createElement('div')
        parsedContent.forEach(element => container.appendChild(element))
        return container
    }

    renderDescription(container, desc) {
        if (container == null) {
            throw Error("Cannot render view. Container is empty.")
        }

        container.innerHTML = ""
        let parsedContent = this.parseDescription(desc)
        parsedContent.forEach(element => container.appendChild(element))

    }
}